import { render, staticRenderFns } from "./BtnDownloadAnexo.vue?vue&type=template&id=98f4e42e&"
import script from "./BtnDownloadAnexo.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports